import AuthActions from "../actions/authAction";
import Path from "../../services/paths";
import CustomToast from '../../util-functions/customToast.jsx'
// import { useHistory } from "react-router-dom";

class AuthMiddleware {
  static authenticate(username, password, history) {
    return dispatch => {
      dispatch(AuthActions.authentication(username, password, history));
      fetch(Path.AUTHENTICATE, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body:
          "username=" +
          username +
          "&password=" +
          password +
          "&grant_type=password" +
          "&client_id=PyCVT8boXecAQ6ne61cyquJKJixuqNLV4IJ4L0ed"
      })
        .then(res => res.json())
        .then(res => {
          if (res.error) {
            CustomToast('error', res.error_description)
            dispatch(AuthActions.authenticationFailed());
          } else {
            const today = new Date();
            const tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
            if (res.otp_sent === true) {
              dispatch(AuthActions.authenticationVerification())
              history.push({
                pathname: '/verification',
                state: { email: username }
              })
            }
            if (res.otp_sent === false) {
              if (res.user?.change_password === false) {
                localStorage.setItem('expiryDate', JSON.stringify(tomorrow));
                localStorage.setItem("myData", JSON.stringify(res));
                dispatch(AuthActions.authenticationSuccessul(res));
              }
              if (res.user?.change_password === true)
                dispatch(AuthActions.authenticationVerification())
              history.push({
                pathname: '/changepassword',
                state: { email: res.user?.username, userId: res.user?.guid, access_token: res.access_token }
              })
            }
          }
        })
        .catch(error => {
          dispatch(AuthActions.authenticationFailed());
        });
    };
  }

  static logOut() {
    return dispatch => {
      dispatch(AuthActions.logout());
    };
  }

  static refreshToken(refresh_token) {
    // alert('error1')
    fetch(Path.REFRESH_TOKEN, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body:
        "refresh_token=" +
        refresh_token +
        "&grant_type=refresh_token" +
        "&client_id=PyCVT8boXecAQ6ne61cyquJKJixuqNLV4IJ4L0ed"
    })
      .then(res => res.json())
      .then(res => {
        if (res.error) {
          localStorage.clear();
          localStorage.removeItem("myData");
          window.location.reload();
        } else {
          var today = new Date();
          var tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
          localStorage.setItem('expiryDate', JSON.stringify(tomorrow));
          localStorage.setItem("myData", JSON.stringify(res));
        }
      })
      .catch(error => {
        localStorage.clear();
        localStorage.removeItem("myData");
        window.location.reload();
      });
  }

  static is_logged_in = () => {
    const user = localStorage.getItem("myData");
    return user ? true : false;
  };

  static on_change_state = callback => {
    const _user = JSON.parse(localStorage.getItem("myData"));
    if (_user) {
      const userData = _user;
      if (new Date(Date.now() + 86400 * 1000) > new Date()) {
      } else {
        AuthMiddleware.logOut();
        const refresh_token = userData.refresh_token;
        AuthMiddleware.refreshToken(refresh_token);
      }
    } else callback(null);
  };

  static verifyUser = (code, history) => {
    return dispatch => {
      dispatch(AuthActions.userVerificationRequest(code, history));
      fetch(`https://staging-unilever.nexdegree.com/b/v1/user/verify/o/?otp=${code}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then(res => res.json())
        .then(res => {
          if (res.error) {
            dispatch(AuthActions.authenticationVerification())
            CustomToast('error', res.error_description)
            dispatch(AuthActions.userVerificationFailed(res.error));
          }
          if (res.detail) {
            dispatch(AuthActions.authenticationVerification())
            CustomToast('error', "Invalid Verification Code")
            dispatch(AuthActions.userVerificationFailed(res.error));
          }
          if (res.user) {
            dispatch(AuthActions.authenticationVerification())
            history.push({
              pathname: '/changepassword',
              state: { email: res?.user?.username, userId: res?.user?.guid, access_token: res.access_token }
            })
          }
        })
        .catch(error => {
          dispatch(AuthActions.userVerificationFailed(error));
        });
    };
  }


  static userChangePassword = (body_, userId, token, history) => {
    return dispatch => {
      dispatch(AuthActions.userChangePasswordRequest());
      fetch(Path.AUTHENTICATE, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body:
          "username=" +
          body_.email +
          "&password=" +
          body_.oldPassword +
          "&grant_type=password" +
          "&client_id=PyCVT8boXecAQ6ne61cyquJKJixuqNLV4IJ4L0ed"
      })
        .then(res => res.json())
        .then(res => {
          if (res.error) {
            CustomToast('error', "Invalid old password")
            dispatch(AuthActions.userChangePasswordFailed());
          } else {
            if (res.user) {
              if (body_.oldPassword.toString().toUpperCase() !== body_.password.toString().toUpperCase()) {
                dispatch(AuthActions.userChangePasswordRequest());
                fetch(`https://staging-unilever.nexdegree.com/b/v1/user/${userId}/update/`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                  },
                  body: JSON.stringify({
                    password: body_.password
                  })
                })
                  .then(res => res.json())
                  .then(res => {
                    if (res.error) {
                      CustomToast('error', res.error_description)
                      dispatch(AuthActions.authenticationVerification())
                      dispatch(AuthActions.userChangePasswordFailed(res.error));
                    } else {
                      dispatch(AuthActions.authenticationVerification())
                      dispatch(AuthActions.logout());
                      history.push('/login')
                    }
                  })
                  .catch(error => {
                    dispatch(AuthActions.userChangePasswordFailed(error));
                  });
              } else {
                CustomToast('error', "Old password and New password cannot be same")
                dispatch(AuthActions.userChangePasswordFailed());
              }
            }
          }
        })
        .catch(error => {
          dispatch(AuthActions.authenticationFailed());
        });

      // dispatch(AuthActions.userChangePasswordRequest(body_, history));
      // fetch(`https://staging-unilever.nexdegree.com/b/v1/user/${userId}/`, {
      //   method: "PUT",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${token}`
      //   },
      //   body: JSON.stringify({
      //     password: body_.password
      //   })
      // })
      //   .then(res => res.json())
      //   .then(res => {
      //     if (res.error) {
      //       CustomToast('error', res.error_description)
      //       dispatch(AuthActions.authenticationVerification())
      //       dispatch(AuthActions.userChangePasswordFailed(res.error));
      //     } else {
      //       dispatch(AuthActions.authenticationVerification())
      //       history.push('/login')
      //     }
      //   })
      //   .catch(error => {
      //     dispatch(AuthActions.userChangePasswordFailed(error));
      //   });
    };
  }

};




export default AuthMiddleware;
